import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Switch, FormControlLabel } from '@mui/material';

export default function ReferralSettingsPage() {
  const [s, setS] = useState({});
  const [msg, setMsg] = useState('');
  const [qrInfo, setQrInfo] = useState({});
  const [uploadMsg, setUploadMsg] = useState('');
  const [musicInfo, setMusicInfo] = useState({});
  const [musicMsg, setMusicMsg] = useState('');
  const tok = localStorage.getItem('dashboard_token');

  const reloadMusic = () => fetch('/api/processing-music/info', { headers:{ Authorization:'Bearer '+tok } })
    .then(r=>r.json()).then(d=>setMusicInfo(d || {}));

  useEffect(() => {
    fetch('/api/qr-logo/info', { headers:{ Authorization:'Bearer '+tok } })
      .then(r=>r.json()).then(d=>setQrInfo(d || {}));
    fetch('/api/referral/settings', { headers:{ Authorization:'Bearer '+tok } })
      .then(r=>r.json()).then(d=>setS(d || {}));
    reloadMusic();
  }, []);

  const upd = (k, v) => setS({...s, [k]: String(v)});
  const isOn = (k) => s[k] === 'true';

  const save = async () => {
    const r = await fetch('/api/referral/settings', {
      method:'POST',
      headers:{ Authorization:'Bearer '+tok, 'Content-Type':'application/json' },
      body: JSON.stringify(s)
    });
    if(r.ok){ setMsg('✅ Збережено!'); setTimeout(()=>setMsg(''),3000); }
  };

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    try {
      const r = await fetch('/api/qr-logo/upload', { method:'POST', headers:{ Authorization:'Bearer '+tok }, body: fd });
      const j = await r.json();
      if (r.ok) {
        setUploadMsg('✅ Завантажено! ' + j.size_kb + 'KB');
        fetch('/api/qr-logo/info', { headers:{ Authorization:'Bearer '+tok } }).then(r=>r.json()).then(d=>setQrInfo(d || {}));
      } else setUploadMsg('❌ ' + (j.detail || 'Помилка'));
      setTimeout(()=>setUploadMsg(''),5000);
    } catch(err) { setUploadMsg('❌ ' + err.message); }
  };

  const deleteQrLogo = async () => {
    if (!window.confirm('Видалити логотип?')) return;
    await fetch('/api/qr-logo', { method:'DELETE', headers:{ Authorization:'Bearer '+tok } });
    setQrInfo({});
    setUploadMsg('🗑 Логотип видалено');
    setTimeout(()=>setUploadMsg(''),3000);
  };

  const handleMusicUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    try {
      const r = await fetch('/api/processing-music/upload', { method:'POST', headers:{ Authorization:'Bearer '+tok }, body: fd });
      const j = await r.json();
      if (r.ok) { setMusicMsg('✅ Завантажено! ' + j.size_kb + 'KB'); reloadMusic(); }
      else setMusicMsg('❌ ' + (j.detail || 'Помилка'));
      setTimeout(()=>setMusicMsg(''),5000);
    } catch(err) { setMusicMsg('❌ ' + err.message); }
  };

  const toggleMusicEnabled = async (v) => {
    await fetch('/api/processing-music/enabled?value=' + v, { method:'POST', headers:{ Authorization:'Bearer '+tok } });
    reloadMusic();
  };

  const deleteMusic = async () => {
    if (!window.confirm('Видалити мелодію?')) return;
    await fetch('/api/processing-music', { method:'DELETE', headers:{ Authorization:'Bearer '+tok } });
    setMusicInfo({});
    setMusicMsg('🗑 Мелодію видалено');
    setTimeout(()=>setMusicMsg(''),3000);
  };

  const Field = ({label, k, type='number'}) => (
    <Box sx={{display:'flex',alignItems:'center',gap:2,mb:2}}>
      <Typography sx={{color:'#aaa',minWidth:240}}>{label}</Typography>
      <TextField size="small" type={type} value={s[k]||''}
        onChange={e=>upd(k,e.target.value)}
        sx={{width:120,'& input':{color:'#fff'},'& .MuiOutlinedInput-notchedOutline':{borderColor:'#555'}}}/>
    </Box>
  );

  const Toggle = ({label, k}) => (
    <FormControlLabel
      control={<Switch checked={isOn(k)} onChange={e=>upd(k,e.target.checked)}/>}
      label={<Typography sx={{color:'#fff'}}>{label}</Typography>}
      sx={{display:'block',mb:1}}/>
  );

  return (
    <Box sx={{p:3}}>
      <Typography variant="h5" sx={{color:'#FFD700',mb:3}}>💎 Реферальна система</Typography>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #FFD700',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#FFD700',mb:2}}>🎯 Основні налаштування</Typography>
        <Toggle label="Система увімкнена" k="referral_system_enabled"/>
        <Field label="Стартовий % (база)" k="base_percent"/>
        <Field label="Крок збільшення %" k="step_percent"/>
        <Field label="Поріг (рефералів) для збільшення" k="step_threshold"/>
        <Field label="Максимальний %" k="max_percent"/>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #4caf50',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#4caf50',mb:2}}>🌐 Multi-Level система</Typography>
        <Toggle label="Multi-level увімкнено" k="multilevel_enabled"/>
        <Field label="L1 (прямий реферал) %" k="level_1_percent"/>
        <Field label="L2 (реферали L1) %" k="level_2_percent"/>
        <Field label="L3 (реферали L2) %" k="level_3_percent"/>
        <Field label="L4 (реферали L3) %" k="level_4_percent"/>
        <Field label="L5 (реферали L4) %" k="level_5_percent"/>
        <Field label="Глибина рівнів (макс 5)" k="multilevel_depth"/>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #2196f3',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#2196f3',mb:2}}>🎁 Trial</Typography>
        <Field label="Trial для рефералів (днів)" k="trial_days_referral"/>
        <Toggle label="Бонусний день за реф" k="bonus_day_enabled"/>
        <Field label="Кількість бонусних днів" k="bonus_day_count"/>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #ff9800',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#ff9800',mb:2}}>💸 Виплати</Typography>
        <Field label="Мінімум виведення (€)" k="min_withdrawal"/>
        <Toggle label="Затримка виплат" k="payout_delay_enabled"/>
        <Field label="Днів затримки" k="payout_delay_days"/>
        <Field label="Період виплат: з числа" k="payout_period_start"/>
        <Field label="Період виплат: по число" k="payout_period_end"/>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid var(--ac1, #7c4dff)',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'var(--ac1, #7c4dff)',mb:2}}>🏆 Топи</Typography>
        <Field label="Кількість топ юзерів" k="top_count"/>
        <Field label="Топ для AI помічника" k="top_for_ai"/>
        <Field label="Топ для відгуків" k="top_for_reviews"/>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #f44336',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#f44336',mb:2}}>🎰 Конкурси</Typography>
        <Toggle label="Конкурси активні" k="contests_active"/>
        <Field label="Тижневий приз (€)" k="weekly_prize"/>
        <Field label="Місячний приз (€)" k="monthly_prize"/>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #e91e63',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#e91e63',mb:2}}>📱 QR Логотип</Typography>
        <Toggle label="Показувати логотип в QR кодах" k="qr_logo_enabled"/>
        <Field label="Розмір логотипа в QR (%)" k="qr_logo_size_percent"/>
        <Box sx={{mt:2}}>
          {qrInfo.url ? (
            <Box sx={{display:'flex',alignItems:'center',gap:2,mb:2}}>
              <img src={qrInfo.url} alt="QR Logo" style={{width:80,height:80,objectFit:'contain',background:'#fff',padding:8,borderRadius:8}}/>
              <Box>
                <Typography sx={{color:'#fff',fontSize:13}}>📁 {qrInfo.filename}</Typography>
                <Button size="small" onClick={deleteQrLogo} sx={{color:'#f44',mt:1}}>🗑 Видалити</Button>
              </Box>
            </Box>
          ) : (
            <Typography sx={{color:'#aaa',fontSize:13,mb:2}}>Логотип не завантажений</Typography>
          )}
          <Button variant="outlined" component="label" sx={{color:'#e91e63',borderColor:'#e91e63'}}>
            📤 Завантажити логотип
            <input type="file" hidden accept=".png,.jpg,.jpeg,.svg" onChange={handleUpload}/>
          </Button>
          {uploadMsg && <Typography sx={{color:'#4caf50',mt:1,fontSize:13}}>{uploadMsg}</Typography>}
          <Typography sx={{color:'#666',fontSize:11,mt:1}}>PNG/JPG/SVG, макс 2MB. Рекомендуємо квадратне зображення.</Typography>
        </Box>
      </Paper>

      {/* 🎵 Мелодія обробки — ПРИБРАНО 2026-08-02. Була окрема одиночна мелодія,
          що дублювала вже наявну БАГАТОТРЕКОВУ Hub-музику (вкладка Avatar →
          Фонова музика, таблиця hub_music). Редактор оверлеїв тепер грає саме її,
          як це зроблено у PlayLanguage. Керування треками — там. */}
      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #f44336',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#f44336',mb:2}}>🛡 Захист від скріну</Typography>
        <Toggle label="Глобально увімкнути для всіх юзерів" k="screen_protection_global"/>
        <Typography sx={{color:'#888',fontSize:12,mt:1}}>Блокує screenshots в чаті бота через protect_content. Можна вимкнути індивідуально в карточці юзера.</Typography>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #00bcd4',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#00bcd4',mb:2}}>🤖 AI агенти</Typography>
        <Toggle label="Антифрод" k="antifraud_active"/>
        <Toggle label="Мотиваційний помічник" k="motivation_ai_active"/>
        <Toggle label="Автопереклад" k="autotranslate_active"/>
        <Toggle label="Адмін-помічник" k="admin_ai_active"/>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #7dfaff',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#7dfaff',mb:2}}>🔢 NUMERIQ — поповнення Monobank</Typography>
        <Toggle label="Monobank увімкнено" k="numeriq_mono_enabled"/>
        <Box sx={{display:'flex',alignItems:'center',gap:2,mb:1}}>
          <Typography sx={{color:'#aaa',minWidth:240}}>Jar-лінк (UAH, send.monobank.ua/...)</Typography>
          <TextField size="small" value={s.numeriq_mono_jar_url_uah||''}
            onChange={e=>upd('numeriq_mono_jar_url_uah',e.target.value)}
            sx={{width:420,'& input':{color:'#fff'},'& .MuiOutlinedInput-notchedOutline':{borderColor:'#555'}}}/>
        </Box>
        <Typography sx={{color:'#666',fontSize:11,mt:1}}>Той самий Monobank-акаунт, що для Media і Хіромантії — окрема банка (jar), окремі суми, платежі не плутаються. Реквізити Revolut для NUMERIQ редагуються на сторінці NUMERIQ → Налаштування.</Typography>
      </Paper>

      <Box sx={{display:'flex',alignItems:'center',gap:2}}>
        <Button variant="contained" onClick={save} sx={{bgcolor:'#FFD700',color:'#000','&:hover':{bgcolor:'#FFC107'}}}>
          💾 Зберегти всі налаштування
        </Button>
        {msg && <Typography sx={{color:'#4caf50'}}>{msg}</Typography>}
      </Box>
    </Box>
  );
}
